import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserPage from 'flarum/forum/components/UserPage';
import LinkButton from 'flarum/common/components/LinkButton';

export function addMeritProfileSection() {
    extend(UserPage.prototype, 'navItems', function (items) {
        const user = this.user;
        if (!user) return;

        items.add('merit', (
            <LinkButton
                href={app.route('user.merit', { username: user.slug() })}
                icon="fas fa-award"
            >
                {app.translator.trans('predictiontalk-merit-system.forum.profile.merit_tab')}
            </LinkButton>
        ), 80);
    });
}
